import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Description } from './styled';
import { Section } from '../styled';
import type { AboutCompanyProps } from '../types';
import { useOnScreen } from '../../../hooks/useOnScreen';

export const AboutCompany: React.FC<AboutCompanyProps> = ({
  setAboutRef,
  setVisibleTabRef
}) => {
  const { t } = useTranslation();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(wrapperRef);

  useEffect(() => {
    setAboutRef?.(wrapperRef);
    if (isVisible) return setVisibleTabRef?.(wrapperRef);
  }, [isVisible]);

  return (
    <Section $setMargin={true} ref={wrapperRef} data-cy="pasha-about">
      <Description tag="p">{t('pasha_about.description')}</Description>
      <Description tag="p">{t('pasha_about.description_1')}</Description>
      <Description tag="p">{t('pasha_about.description_2')}</Description>
    </Section>
  );
};
